import { HighlightedReviewUI } from "./HighlightedReviewUI";
import { StandardProps } from "../componentMap";
import { ensureIsActive } from "../../utils/product/ensureIsActive";
import { useEffect } from "react";
import { PRODUCT_REVIEWS_ACCORDION_INSTANCE_NAME } from "../ProductAccordion/components/ProductReviewsAccordion/ProductReviewsAccordionUI";
import { VIEW_ALL_REVIEWS } from "../../constants/constants";

export function HighlightedReview({
  product,
  runtimeConfig,
  experiencesRawObject,
  flags,
}: Pick<
  StandardProps,
  "product" | "runtimeConfig" | "experiencesRawObject" | "flags"
>) {
  const { highlightedReviewScriptUrl, reviewsApiKey } = runtimeConfig;
  const activeProduct = ensureIsActive(product);
  const useNewTypography = flags.useNewTypography.value === true;

  useEffect(() => {
    const handleOpenAccordion = () => {
      document.body.dispatchEvent(
        new CustomEvent(
          `jlds:accordion:${PRODUCT_REVIEWS_ACCORDION_INSTANCE_NAME}`,
          {
            detail: { action: "open" },
          },
        ),
      );
    };

    document.body.addEventListener(VIEW_ALL_REVIEWS, handleOpenAccordion);
    return () => {
      document.body.removeEventListener(VIEW_ALL_REVIEWS, handleOpenAccordion);
    };
  }, []);

  useEffect(() => {
    const jlRecsScript = document.createElement("script");
    jlRecsScript.setAttribute("type", "text/javascript");
    jlRecsScript.setAttribute("data-testid", "highlighted-review-script");
    jlRecsScript.setAttribute("src", highlightedReviewScriptUrl);
    document.body.appendChild(jlRecsScript);

    return () => {
      if (document.body.contains(jlRecsScript)) {
        document.body.removeChild(jlRecsScript);
      }
    };
  }, [highlightedReviewScriptUrl]);

  if (!activeProduct) return null;

  return (
    <HighlightedReviewUI
      productId={activeProduct.aliases.pimProductId}
      apiKey={reviewsApiKey}
      clientId="standard-pdp-ui"
      experiencesRawObject={experiencesRawObject}
      useNewTypography={useNewTypography}
    />
  );
}
